import ClassSchedule from '../components/ClassSchedule';
import SEO from '../components/SEO';
import { MEDIA_STATUS } from '../lib/mediaTruth';
import { ScheduleNavigation, ScheduleHero, ScheduleMedia, ClassLedger } from './SchedulePresentation';
import { TourClosing } from '../components/TourJourney';

const categoryContent = {
  'mind-body': {
    facts: ['Yoga, Barre & Mat Pilates', 'Power Stretch & more', 'Included with membership'],
    title: 'Mind-Body',
    eyebrow: 'Elevate Your Essence',
    description: 'Build strength, mobility, balance, and calm through Yoga, Barre, Mat Pilates, Power Stretch, and other mind-body classes.',
    classes: [
      ['Yoga', 'Mindful movement, breath work, flexibility, and strength for all experience levels.'],
      ['Yoga Muscle Fusion', 'A balanced combination of yoga movement and muscle-conditioning exercises.'],
      ['Barre', 'Ballet-inspired movements that sculpt, strengthen, and improve posture.'],
      ['Mat Pilates', 'Core-focused, low-impact conditioning designed to improve stability and control.'],
      ['Yoga Flow', 'A fluid practice connecting breath and movement to build mobility and focus.'],
      ['Barre-Lates', 'A fusion of barre and Pilates for full-body strength and toning.'],
      ['Power Stretch', 'Dedicated mobility work to help improve range of motion and recovery.'],
      ['Water Aerobics', 'Joint-friendly resistance and cardio training in the pool.'],
    ],
  },
  'weight-training': {
    facts: ['Coached group classes', 'Full-body strength & conditioning', 'Included with membership'],
    title: 'Weight Training',
    eyebrow: '#1 Place to Workout in Brentwood',
    description: 'Build strength, improve conditioning, and train the full body through coached weight-based group classes.',
    classes: [
      ['Body Blast', 'A high-energy blend of resistance work and cardio intervals.'],
      ['F.I.T.', 'Functional interval training designed to challenge strength and endurance.'],
      ['Muscle Mania', 'Focused resistance training for major muscle groups.'],
      ['Overall Body', 'A complete strength workout covering upper body, lower body, and core.'],
      ['Muscle Pump', 'High-repetition resistance training that builds muscular endurance.'],
      ['Morning Muscle', 'An energizing early-day strength session to start the day strong.'],
    ],
  },
};

const mindBodyMedia = {
  id: 'schedule-mind-body', label: 'Mind-Body classes', src: null,
  status: MEDIA_STATUS.BLOCKED,
};

const ScheduleCategoryPage = ({ category }) => {
  const content = categoryContent[category];
  const scheduleId = `${category}-schedule`;
  return (
    <main className="dv-class-pages" data-testid={`schedule-${category}-page`}>
      <SEO
        title={`${content.title} Classes`}
        description={`${content.description} View the current Delta Valley Health Club schedule.`}
        keywords={`${content.title} Brentwood, Delta Valley group classes, Brentwood fitness schedule`}
      />
      <ScheduleHero title={content.title} scheduleId={scheduleId} facts={content.facts} media={category === 'mind-body' ?
        <ScheduleMedia media={mindBodyMedia} /> :
        <ScheduleMedia src="/images/facility/dumbells.jpg" asset="F05" alt="Dumbbells on a training floor" caption="Strength equipment" />
      }>
        <p className="dv-size-lede text-lg leading-relaxed">{content.description}</p>
      </ScheduleHero>
      <ScheduleNavigation current={`/schedule/${category}`} />
      <section className="dv-class-pages__catalog" aria-labelledby="category-classes-title">
        <div className="dv-class-pages__catalog-intro">
          <p className="dv-class-pages__eyebrow text-sm font-bold uppercase tracking-[0.2em]">Included with membership</p>
          <h2 id="category-classes-title" className="dv-size-heading text-3xl font-black uppercase md:text-4xl">{content.eyebrow}</h2>
        </div>
        <ClassLedger classes={content.classes} />
      </section>
      <section className="dv-class-pages__schedule" id={scheduleId} aria-labelledby="category-schedule-title">
        <div className="dv-class-pages__schedule-heading">
          <div>
            <p className="dv-class-pages__eyebrow text-sm font-bold uppercase tracking-[0.2em]">Updated live</p>
            <h2 id="category-schedule-title" className="dv-size-heading text-3xl font-bold md:text-4xl">{content.title} Schedule</h2>
            <p className="dv-size-body">This view opens on {content.title} classes. Pick a day, switch programs, or narrow by time of day or instructor.</p>
          </div>
        </div>
        <ClassSchedule focus={category === 'weight-training' ? 'strength' : category} categoryId="9" title={`Delta Valley Health Club ${content.title} weekly schedule`} />
      </section>
      <TourClosing />
    </main>
  );
};

export default ScheduleCategoryPage;
